import React, { useEffect } from "react";

export default function Toast({ message, type = "success", onClose }) {
  useEffect(() => {
    const timer = window.setTimeout(() => {
      onClose?.();
    }, 2600);

    return () => window.clearTimeout(timer);
  }, [onClose]);

  return (
    <div className={`ac-toast ac-toast--${type}`} role="status" aria-live="polite">
      <div className="ac-toast__icon" aria-hidden="true">
        {type === "error" ? "!" : "✓"}
      </div>
      <div className="ac-toast__content">{message}</div>
      <button
        type="button"
        className="ac-toast__close"
        onClick={onClose}
        aria-label="Toast schließen"
      >
        ×
      </button>
    </div>
  );
}